import {
    HandTypes,
    REMOVE_FROM_HAND,
    SET_HAND,
    EMPTY_HAND,
    ADD_TO_HAND,
} from '../types';
const handReducer = (state = [], action: HandTypes) => {
    switch (action.type) {
        case SET_HAND:
            state = action.hand;
            return state;
        case REMOVE_FROM_HAND:
            state.splice(action.idx, 1);
            return [...state];
        case ADD_TO_HAND:
            return [...state, action.item];
        case EMPTY_HAND:
            return [];
        default:
            return state;
    }
};

export default handReducer;
